module.exports = __webpack_public_path__ + "static/img/ball32.311531b6.png";